import React, {useState, useCallback} from 'react';
import LoadIndicator from '../../components/common/loading/LoadIndicator';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import Select from 'react-select';
import {useCountryCode} from 'epic-ue-shared';
import {getInitialCmsPageSharedValues, PageData, useCmsData} from 'epic-ue-shared';
import Error404 from '../error/Error404';

interface CandidateProps {
    candidates: {
        content: string;
        country: string;
        language: string;
    }[];
}
interface CandidatePageData extends PageData {
    candidates: CandidateProps;
}
interface Content {
    content?: string;
}

const cmsUrlPattern = '/candidateprivacynotice';

const CandidateView = (): JSX.Element => {
    const {cmsLoading, cmsLoadedEmpty, pageData} = useCmsData<CandidatePageData>(cmsUrlPattern);
    const countryCode = useCountryCode();
    const candidates: CandidateProps = pageData.candidates || ({} as CandidateProps);
    const listData = candidates.candidates || [];
    const initContent = listData.find((item) => item.country.toUpperCase() === countryCode);
    const [selectedOption, setSelectedOption] = useState(
        initContent
            ? {value: initContent.country, label: initContent.language}
            : {value: 'US', label: 'English'}
    );
    const selectedContent: Content =
        listData.find((item) => item.country === selectedOption.value) || {};

    const onLanguageChange = useCallback(
        (selectedOption) => {
            setSelectedOption(selectedOption);
        },
        [setSelectedOption]
    );

    if (cmsLoading) {
        return (
            <div className="candidate-view">
                {getHelmetForMetaTags(pageData)}
                <LoadIndicator />
            </div>
        );
    }

    if (cmsLoadedEmpty) {
        return <Error404 />;
    }

    return (
        <div className="candidate-view cms-page">
            {getHelmetForMetaTags(pageData)}
            {listData.length > 0 && (
                <div className="container">
                    <div className="selectContainer">
                        <Select
                            value={selectedOption}
                            isSearchable={false}
                            className="lanuageOption"
                            options={[
                                ...listData.map((item) => ({
                                    value: item.country,
                                    label: item.language
                                }))
                            ]}
                            onChange={onLanguageChange}
                        />
                    </div>
                    <div
                        className="cms-page-content"
                        dangerouslySetInnerHTML={{__html: selectedContent.content || ''}}
                    />
                </div>
            )}
        </div>
    );
};

CandidateView.getInitialSharedValues = getInitialCmsPageSharedValues(cmsUrlPattern);

export default CandidateView;
